import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

export const SegmentDropdown = ({
    placeholder,
    value,
    options = [],
    onChange,
    optionLabel = 'name',
    optionValue,
    showClear = true,
    className = '',
    id,
    disabled = false,
    filter = false,
    loading = false,
    name,
    style,
    ...rest
}) => {
    return (
        <Dropdown
            placeholder={placeholder}
            style={style}
            value={value}
            options={options}
            onChange={onChange}
            optionLabel={optionLabel}
            optionValue={optionValue}
            showClear={showClear}
            disabled={disabled}
            filter={filter}
            loading={loading}
            name={name}
            className={`text-left items-center export-dropdown ${className}`}
            id={id}
            {...rest}
        />
    );
};


export const TagMultiselect = ({
    placeholder,
    value,
    options = [],
    onChange,
    optionLabel = 'name',
    optionValue = 'value',
    optionGroupLabel = 'label',
    optionGroupChildren = 'label',
    showSelectAll = false,
    className = '',
    panelClassName = '',
    display = "chip",
    id,
    disabled = false,
    style,
    showClear
}) => {
    return (
        <MultiSelect
            className={className}
            panelClassName={panelClassName}
            id={id}
            value={value}
            onChange={onChange}
            options={options}
            optionLabel={optionLabel}
            optionValue={optionValue}
            optionGroupLabel={optionGroupLabel}
            optionGroupChildren={optionGroupChildren}
            placeholder={placeholder}
            disabled={disabled}
            showSelectAll={showSelectAll}
            display={display}
            style={style}
            showClear={showClear}
        />
    );
};

